import { render } from "./Separator.vue?vue&type=template&id=1e685080&scoped=true"
const script = {}

import "./Separator.vue?vue&type=style&index=0&id=1e685080&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e685080"]])

export default __exports__